<template>
    <div>
        <SphereNavigation color="blue" selected="appointment-menu" />

        <div class="inner-content">
            <h1>{{$t('appointments.type_title')}}</h1>

            <p>{{$t('appointments.type_text')}}</p>

            <div class="action-btns">
                <button type="button" class="btn-basic blue" @click.prevent="clickMeasurement">
                    {{$t('appointments.measurement')}}
                </button>
                <button type="button" class="btn-basic blue" @click.prevent="clickService">
                    {{$t('appointments.service')}}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import SphereNavigation from "@/components/app/SphereNavigation.vue";
import {apiStore} from "@/stores/api";

export default {
    name : "AppointmentMenu",
    components : {
        SphereNavigation
    },

    data() {
        return {
            id: null,
            nextRoute: null
        };
    },

    created() {
        this.id = this.$route.params.id || null;

        this.nextRoute = this.$route.params.nextRoute || "appointment-edit";
    },

    methods: {
        clickMeasurement() {
            apiStore().measurementType = "measurement";
            this.navigate();
        },

        clickService() {
            apiStore().measurementType = "service";
            this.navigate();
        },

        navigate() {
            const params = {};
            if (this.id) {
                params.id = this.id;
            }

            this.$router.push({name : this.nextRoute, params});
        }
    }
};
</script>

<style lang="scss" scoped>
    .inner-content {
        p {
            @include slideIntroAnimation(title, 500ms, 300ms);
        }

        .action-btns {
            margin-top : 5rem;
            text-align : left;
            margin-left: 11%;

            .btn-basic {
                padding : 0 2rem;
                margin-right : 1rem;
                margin-bottom : 1rem;
            }
        }
    }
</style>